<app-common-dialog-wrapper
  [headerText]="headerText"
  (onDialogClose)="onDialogClose()"
  >
  <section class="data-section">
    @if (selectOption) {
      <div class="filter-type">
        <mds-dropdown-menu
          [options]="dataSetTypes"
          [formControl]="selectedType"
        ></mds-dropdown-menu>
      </div>
    }
    <mds-search-bar
      [placeholder]="placeholder"
      [formControl]="searchText"
      theme="light"
      [hideEnterButton]="true"
    ></mds-search-bar>

    <section class="data-section__results">
      @for (s of searchResults; track s; let parentIndex = $index) {
        <div
          style="margin-bottom: 16px"
          >
          @for (data of s.cards; track data; let childIndex = $index) {
            <div
          (click)="
            multiSelect ? updateTilesSelection(data, $event) : openProduct(data)
          "
              class="product-container"
              >
              @if (multiSelect) {
                <mds-checkbox
                  [ariaLabel]="data.title"
                  [value]="selectedTilesRid.includes(data.rid)"
                  name="select product"
                  (change)="updateTilesSelection(data); $event.stopPropagation()"
                  >
                </mds-checkbox>
              }
              @if (!multiSelect) {
                <a
                  class="tile-container-link"
                  attr.aria-label="open {{ data.name || data.title }}"
                  role="button"
                  tabindex="0"
                  (click)="openProduct(data)"
                  (keyup.enter)="openProduct(data)"
                  >
                  <mds-object-card
                    [compact]="'true'"
                    [data]="data"
                  ></mds-object-card>
                </a>
              }
              @if (multiSelect) {
                <mds-object-card
                  [compact]="'true'"
                  [data]="data"
                ></mds-object-card>
              }
            </div>
          }
          @if (s.cards.length === 0) {
            <div class="no-result-found">
              No Result Found
            </div>
          }
        </div>
      }
    </section>
  </section>
  @if (multiSelect) {
    <footer custom-bottom-buttons class="footer-section">
      @if (data['type'] != 'pef-product-search') {
        <div
          class="footer-section__left-buttons"
          >
          @if (selectedTilesRid.length != searchResultsCount) {
            <mds-button
              aria-label="select all products"
              type="secondary"
              size="medium"
              (click)="selectAll()"
              >
              {{ selectAllText }}
            </mds-button>
          }
          @if (selectedTilesRid.length > 0) {
            <mds-button
              aria-label="deselect all products"
              type="secondary"
              size="medium"
              (click)="clearSelections()"
              >
              {{ deSelectAllText }}
            </mds-button>
          }
        </div>
      }
      @if (data['type'] == 'pef-product-search' && maxSelection) {
        <div>
          @if (selectedTilesRid.length < maxSelection) {
            <span
              >Select upto {{ maxSelection }} Alternatives to be compared with the
              Reference</span
              >
            }
            @if (selectedTilesRid.length >= maxSelection) {
              <span class="max-selected"
                >Maximum number of Alternatives reached</span
                >
              }
            </div>
          }
          <div class="footer-section__right-buttons">
            <mds-button type="secondary" size="medium" (click)="closeModal()">
              Cancel
            </mds-button>
            <mds-button
              type="primary"
              size="medium"
              [disabled]="selectedTilesRid && selectedTilesRid.length < 1"
              (click)="selectProducts()"
              >
              {{ submitButtonText }}
            </mds-button>
          </div>
        </footer>
      }
    </app-common-dialog-wrapper>
